var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "footer"
  }, [_c("a", {
    attrs: {
      target: "_blank",
      href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011302003878"
    }
  }, [_c("img", {
    staticStyle: {
      float: "left"
    },
    attrs: {
      src: ""
    }
  }), _vm._v("京公网安备 11011302003878号")]), _c("span", {
    staticStyle: {
      color: "#666666",
      "margin-right": "20px"
    }
  }, [_vm._v("©Copyright 2021 全联图书出版发行有限公司 版权所有 ")]), _c("a", {
    attrs: {
      target: "blank",
      href: "http://beian.miit.gov.cn"
    }
  }, [_vm._v("京ICP备2021041340号-1")]), _c("a", {
    attrs: {
      target: "blank",
      href: "http://pc.qlcnbook.com/pic/20220519-142800.jpg"
    }
  }, [_vm._v("出版物经营许可证 新出发京批字第直210435号-1")]), _c("a", {
    attrs: {
      target: "blank",
      href: "http://pc.qlcnbook.com/pic/icp20240516.jpg"
    }
  }, [_vm._v("经营许可证编号：京B2-20223982")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };